import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

const tabs = [
  { lines: ["CO", "Pending", "Loans"], to: "/actions/loans/co" },
  { lines: ["Pending", "Loans"], to: "/actions/loans/pending" },
  { lines: ["Pending", "Disbursement"], to: "/actions/loans/pending-disbursement" },
   { lines: ["Queued"], to: "/actions/loans/queued-disbursement" },
  { lines: ["All","Loans"], to: "/actions/loans/active" },
  { lines: ["Defaulted"], to: "/actions/loans/defaulted" },
  
];

export function ActionLoanMenu() {
  return (
      <div className="bg-card border border-border rounded-xl p-1 sm:p-2 lg:p-3">
        {/* 
          Mobile: grid (2 cols)
          Tablet: flex row (wrap if needed) + 2-line labels
          Desktop: centered row + 1-line labels
        */}
        <div
          className={cn(
            // mobile
            "grid grid-cols-2 gap-2",
  
            // tablet (no scroll, allow wrap if tight)
            "md:flex md:flex-wrap md:gap-2 md:justify-center",
  
            // desktop
            "lg:flex-nowrap lg:justify-center"
          )}
        >
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                cn(
                  // base
                  "uppercase rounded-xl border transition-all duration-200",
                  "flex items-center justify-center text-center",
  
                  // mobile
                  "min-h-[56px] px-2 py-2 text-[11px] leading-tight",
  
                  // tablet: slightly smaller, still 2-line
                  "md:min-h-[52px] md:px-3 md:py-2 md:text-[12px] md:rounded-xl",
  
                  // desktop: pill + single line
                  "lg:min-h-0 lg:h-10 lg:px-4 lg:py-2 lg:text-sm lg:rounded-full lg:whitespace-nowrap",
  
                  isActive
                    ? "bg-primary text-primary-foreground border-primary/30 shadow-sm"
                    : "bg-background text-muted-foreground border-border hover:text-foreground hover:bg-muted"
                )
              }
            >
              <span className="font-semibold">
                {/* Mobile + Tablet: multi-line */}
                <span className="block lg:hidden">
                  {tab.lines.map((t, i) => (
                    <span key={i} className="block">
                      {t}
                    </span>
                  ))}
                </span>
  
                {/* Desktop: single line */}
                <span className="hidden lg:inline">{tab.lines.join(" ")}</span>
              </span>
            </NavLink>
          ))}
        </div>
      </div>
    );
}
